module.exports = __webpack_public_path__ + "img/message-exclamation.4a42c85e.svg";